import { c as __awaiter, d as __generator, _ as __rest, a as __assign$2 } from './tslib.es6-18cb2814.js';
import { c as classNames } from './index-8887fc24.js';
import React__default, { useEffect, useMemo, useState, useCallback } from 'react';
import { animated, useSpring } from 'react-spring';
import require$$0 from 'react/jsx-runtime';
import require$$2__default from 'react-dom';
import { a as useStackingContext } from './useOrchard-45cfc194.js';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
				var args = [null];
				args.push.apply(args, arguments);
				var Ctor = Function.bind.apply(f, args);
				return new Ctor();
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var Popover$1 = {};

var PopoverPortal$1 = {};

Object.defineProperty(PopoverPortal$1, "__esModule", { value: true });
PopoverPortal$1.PopoverPortal = void 0;
var react_1$5 = React__default;
var react_dom_1 = require$$2__default;
var PopoverPortal = function (_a) {
    var container = _a.container, element = _a.element, scoutElement = _a.scoutElement, children = _a.children;
    react_1$5.useLayoutEffect(function () {
        container.appendChild(element);
        container.appendChild(scoutElement);
        return function () {
            container.removeChild(element);
            container.removeChild(scoutElement);
        };
    }, [container, element, scoutElement]);
    return react_dom_1.createPortal(children, element);
};
PopoverPortal$1.PopoverPortal = PopoverPortal;

var util = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getNudgedPopoverRect = exports.getNewPopoverRect = exports.popoverRectForPosition = exports.createContainer = exports.rectsAreEqual = exports.EMPTY_CLIENT_RECT = void 0;
	exports.EMPTY_CLIENT_RECT = {
	    top: 0,
	    left: 0,
	    bottom: 0,
	    height: 0,
	    right: 0,
	    width: 0,
	};
	var rectsAreEqual = function (rectA, rectB) {
	    return rectA === rectB ||
	        ((rectA === null || rectA === void 0 ? void 0 : rectA.bottom) === (rectB === null || rectB === void 0 ? void 0 : rectB.bottom) &&
	            (rectA === null || rectA === void 0 ? void 0 : rectA.height) === (rectB === null || rectB === void 0 ? void 0 : rectB.height) &&
	            (rectA === null || rectA === void 0 ? void 0 : rectA.left) === (rectB === null || rectB === void 0 ? void 0 : rectB.left) &&
	            (rectA === null || rectA === void 0 ? void 0 : rectA.right) === (rectB === null || rectB === void 0 ? void 0 : rectB.right) &&
	            (rectA === null || rectA === void 0 ? void 0 : rectA.top) === (rectB === null || rectB === void 0 ? void 0 : rectB.top) &&
	            (rectA === null || rectA === void 0 ? void 0 : rectA.width) === (rectB === null || rectB === void 0 ? void 0 : rectB.width));
	};
	exports.rectsAreEqual = rectsAreEqual;
	var createContainer = function (containerStyle, containerClassName) {
	    var container = window.document.createElement('div');
	    if (containerClassName)
	        container.className = containerClassName;
	    Object.assign(container.style, containerStyle);
	    return container;
	};
	exports.createContainer = createContainer;
	var popoverRectForPosition = function (position, childRect, popoverRect, padding, align) {
	    var targetMidX = childRect.left + childRect.width / 2;
	    var targetMidY = childRect.top + childRect.height / 2;
	    var width = popoverRect.width, height = popoverRect.height;
	    var top;
	    var left;
	    switch (position) {
	        case 'left':
	            top = targetMidY - height / 2;
	            left = childRect.left - padding - width;
	            if (align === 'start') {
	                top = childRect.top;
	            }
	            if (align === 'end') {
	                top = childRect.bottom - height;
	            }
	            break;
	        case 'bottom':
	            top = childRect.bottom + padding;
	            left = targetMidX - width / 2;
	            if (align === 'start') {
	                left = childRect.left;
	            }
	            if (align === 'end') {
	                left = childRect.right - width;
	            }
	            break;
	        case 'right':
	            top = targetMidY - height / 2;
	            left = childRect.right + padding;
	            if (align === 'start') {
	                top = childRect.top;
	            }
	            if (align === 'end') {
	                top = childRect.bottom - height;
	            }
	            break;
	        default:
	            top = childRect.top - height - padding;
	            left = targetMidX - width / 2;
	            if (align === 'start') {
	                left = childRect.left;
	            }
	            if (align === 'end') {
	                left = childRect.right - width;
	            }
	            break;
	    }
	    return { top: top, left: left, width: width, height: height, right: left + width, bottom: top + height };
	};
	exports.popoverRectForPosition = popoverRectForPosition;
	var getNewPopoverRect = function (_a, boundaryInset) {
	    var position = _a.position, align = _a.align, childRect = _a.childRect, popoverRect = _a.popoverRect, boundaryRect = _a.boundaryRect, padding = _a.padding, reposition = _a.reposition;
	    var rect = exports.popoverRectForPosition(position, childRect, popoverRect, padding, align);
	    var boundaryViolation = reposition &&
	        ((position === 'top' && rect.top < boundaryRect.top + boundaryInset) ||
	            (position === 'left' && rect.left < boundaryRect.left + boundaryInset) ||
	            (position === 'right' && rect.right > boundaryRect.right - boundaryInset) ||
	            (position === 'bottom' && rect.bottom > boundaryRect.bottom - boundaryInset));
	    return {
	        rect: rect,
	        boundaryViolation: boundaryViolation,
	    };
	};
	exports.getNewPopoverRect = getNewPopoverRect;
	var getNudgedPopoverRect = function (popoverRect, boundaryRect, boundaryInset) {
	    var topBoundary = boundaryRect.top + boundaryInset;
	    var leftBoundary = boundaryRect.left + boundaryInset;
	    var rightBoundary = boundaryRect.right - boundaryInset;
	    var bottomBoundary = boundaryRect.bottom - boundaryInset;
	    var top = popoverRect.top < topBoundary ? topBoundary : popoverRect.top;
	    top = top + popoverRect.height > bottomBoundary ? bottomBoundary - popoverRect.height : top;
	    var left = popoverRect.left < leftBoundary ? leftBoundary : popoverRect.left;
	    left = left + popoverRect.width > rightBoundary ? rightBoundary - popoverRect.width : left;
	    return {
	        top: top,
	        left: left,
	        width: popoverRect.width,
	        height: popoverRect.height,
	        right: left + popoverRect.width,
	        bottom: top + popoverRect.height,
	    };
	};
	exports.getNudgedPopoverRect = getNudgedPopoverRect;
	
} (util));

var usePopover$1 = {};

var useElementRef$1 = {};

Object.defineProperty(useElementRef$1, "__esModule", { value: true });
useElementRef$1.useElementRef = void 0;
var react_1$4 = React__default;
var util_1$1 = util;
var useElementRef = function (containerClassName, containerStyle) {
    var ref = react_1$4.useRef();
    var element = react_1$4.useMemo(function () { return util_1$1.createContainer(containerStyle, containerClassName); }, [containerClassName, containerStyle]);
    ref.current = element;
    return ref;
};
useElementRef$1.useElementRef = useElementRef;

Object.defineProperty(usePopover$1, "__esModule", { value: true });
usePopover$1.usePopover = void 0;
var react_1$3 = React__default;
var util_1 = util;
var useElementRef_1 = useElementRef$1;
var POPOVER_STYLE = {
    position: 'fixed',
    overflow: 'visible',
    top: '0px',
    left: '0px',
};
var SCOUT_STYLE = {
    position: 'fixed',
    top: '0px',
    left: '0px',
    width: '0px',
    height: '0px',
    visibility: 'hidden',
};
var usePopover = function (_a) {
    var isOpen = _a.isOpen, childRef = _a.childRef, positions = _a.positions, containerClassName = _a.containerClassName, parentElement = _a.parentElement, contentLocation = _a.contentLocation, align = _a.align, padding = _a.padding, reposition = _a.reposition, boundaryInset = _a.boundaryInset, boundaryElement = _a.boundaryElement, onPositionPopover = _a.onPositionPopover;
    var popoverRef = useElementRef_1.useElementRef(containerClassName, POPOVER_STYLE);
    var scoutRef = useElementRef_1.useElementRef('react-tiny-popover-scout', SCOUT_STYLE);
    var positionPopover = react_1$3.useCallback(function (_a) {
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, _e = _d.positionIndex, positionIndex = _e === void 0 ? 0 : _e, _f = _d.parentRect, parentRect = _f === void 0 ? parentElement.getBoundingClientRect() : _f, _g = _d.childRect, childRect = _g === void 0 ? (_b = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect() : _g, _h = _d.scoutRect, scoutRect = _h === void 0 ? (_c = scoutRef === null || scoutRef === void 0 ? void 0 : scoutRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect() : _h, _j = _d.popoverRect, popoverRect = _j === void 0 ? popoverRef.current.getBoundingClientRect() : _j, _k = _d.boundaryRect, boundaryRect = _k === void 0 ? boundaryElement === parentElement
            ? parentRect
            : boundaryElement.getBoundingClientRect() : _k;
        if (!childRect || !parentRect || !isOpen) {
            return;
        }
        if (contentLocation) {
            var _l = typeof contentLocation === 'function'
                ? contentLocation({
                    childRect: childRect,
                    popoverRect: popoverRect,
                    parentRect: parentRect,
                    boundaryRect: boundaryRect,
                    padding: padding,
                    nudgedTop: 0,
                    nudgedLeft: 0,
                    boundaryInset: boundaryInset,
                    violations: util_1.EMPTY_CLIENT_RECT,
                    hasViolations: false,
                })
                : contentLocation, inputTop = _l.top, inputLeft = _l.left;
            var left_1 = Math.round(parentRect.left + inputLeft - scoutRect.left);
            var top_1 = Math.round(parentRect.top + inputTop - scoutRect.top);
            popoverRef.current.style.transform = "translate(" + left_1 + "px, " + top_1 + "px)";
            onPositionPopover({
                childRect: childRect,
                popoverRect: popoverRect,
                parentRect: parentRect,
                boundaryRect: boundaryRect,
                padding: padding,
                nudgedTop: 0,
                nudgedLeft: 0,
                boundaryInset: boundaryInset,
                violations: util_1.EMPTY_CLIENT_RECT,
                hasViolations: false,
            });
            return;
        }
        var isExhausted = positionIndex === positions.length;
        var position = isExhausted ? positions[0] : positions[positionIndex];
        var _m = util_1.getNewPopoverRect({
            childRect: childRect,
            popoverRect: popoverRect,
            boundaryRect: boundaryRect,
            position: position,
            align: align,
            padding: padding,
            reposition: reposition,
        }, boundaryInset), rect = _m.rect, boundaryViolation = _m.boundaryViolation;
        if (boundaryViolation && reposition && !isExhausted) {
            positionPopover({
                positionIndex: positionIndex + 1,
                childRect: childRect,
                popoverRect: popoverRect,
                parentRect: parentRect,
                boundaryRect: boundaryRect,
            });
            return;
        }
        var top = rect.top, left = rect.left, width = rect.width, height = rect.height;
        var shouldNudge = reposition && !isExhausted;
        var _o = util_1.getNudgedPopoverRect(rect, boundaryRect, boundaryInset), nudgedLeft = _o.left, nudgedTop = _o.top;
        var finalTop = top;
        var finalLeft = left;
        if (shouldNudge) {
            finalTop = nudgedTop;
            finalLeft = nudgedLeft;
        }
        finalTop = Math.round(finalTop - scoutRect.top);
        finalLeft = Math.round(finalLeft - scoutRect.left);
        popoverRef.current.style.transform = "translate(" + finalLeft + "px, " + finalTop + "px)";
        var potentialViolations = {
            top: boundaryRect.top + boundaryInset - finalTop,
            left: boundaryRect.left + boundaryInset - finalLeft,
            right: finalLeft + width - boundaryRect.right + boundaryInset,
            bottom: finalTop + height - boundaryRect.bottom + boundaryInset,
        };
        onPositionPopover({
            childRect: childRect,
            popoverRect: {
                top: finalTop,
                left: finalLeft,
                width: width,
                height: height,
                right: finalLeft + width,
                bottom: finalTop + height,
            },
            parentRect: parentRect,
            boundaryRect: boundaryRect,
            position: position,
            align: align,
            padding: padding,
            nudgedTop: nudgedTop - top,
            nudgedLeft: nudgedLeft - left,
            boundaryInset: boundaryInset,
            violations: {
                top: potentialViolations.top <= 0 ? 0 : potentialViolations.top,
                left: potentialViolations.left <= 0 ? 0 : potentialViolations.left,
                right: potentialViolations.right <= 0 ? 0 : potentialViolations.right,
                bottom: potentialViolations.bottom <= 0 ? 0 : potentialViolations.bottom,
            },
            hasViolations: potentialViolations.top > 0 ||
                potentialViolations.left > 0 ||
                potentialViolations.right > 0 ||
                potentialViolations.bottom > 0,
        });
    }, [
        parentElement,
        childRef,
        scoutRef,
        popoverRef,
        boundaryElement,
        isOpen,
        contentLocation,
        positions,
        align,
        padding,
        reposition,
        boundaryInset,
        onPositionPopover,
    ]);
    return {
        positionPopover: positionPopover,
        popoverRef: popoverRef,
        scoutRef: scoutRef,
    };
};
usePopover$1.usePopover = usePopover;

var useMemoizedArray$1 = {};

Object.defineProperty(useMemoizedArray$1, "__esModule", { value: true });
useMemoizedArray$1.useMemoizedArray = void 0;
var react_1$2 = React__default;
var useMemoizedArray = function (externalArray) {
    var prevArrayRef = react_1$2.useRef(externalArray);
    var array = react_1$2.useMemo(function () {
        if (prevArrayRef.current === externalArray)
            return prevArrayRef.current;
        if (prevArrayRef.current.length !== externalArray.length) {
            prevArrayRef.current = externalArray;
            return externalArray;
        }
        for (var i = 0; i < externalArray.length; i += 1) {
            if (externalArray[i] !== prevArrayRef.current[i]) {
                prevArrayRef.current = externalArray;
                return externalArray;
            }
        }
        return prevArrayRef.current;
    }, [externalArray]);
    return array;
};
useMemoizedArray$1.useMemoizedArray = useMemoizedArray;

var useArrowContainer$1 = {};

var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
Object.defineProperty(useArrowContainer$1, "__esModule", { value: true });
useArrowContainer$1.useArrowContainer = void 0;
var react_1$1 = React__default;
var useArrowContainer = function (_a) {
    var childRect = _a.childRect, popoverRect = _a.popoverRect, position = _a.position, arrowSize = _a.arrowSize, arrowColor = _a.arrowColor;
    var arrowContainerStyle = react_1$1.useMemo(function () {
        return ({
            padding: arrowSize,
        });
    }, [arrowSize]);
    var arrowStyle = react_1$1.useMemo(function () {
        return (__assign$1({ position: 'absolute' }, (function () {
            var arrowWidth = arrowSize * 2;
            var top = childRect.top - popoverRect.top + childRect.height / 2 - arrowWidth / 2;
            var left = childRect.left - popoverRect.left + childRect.width / 2 - arrowWidth / 2;
            var lowerBound = arrowSize;
            var leftUpperBound = popoverRect.width - arrowSize;
            var topUpperBound = popoverRect.height - arrowSize;
            left = left < lowerBound ? lowerBound : left;
            left = left + arrowWidth > leftUpperBound ? leftUpperBound - arrowWidth : left;
            top = top < lowerBound ? lowerBound : top;
            top = top + arrowWidth > topUpperBound ? topUpperBound - arrowWidth : top;
            top = Number.isNaN(top) ? 0 : top;
            left = Number.isNaN(left) ? 0 : left;
            switch (position) {
                case 'right':
                    return {
                        borderTop: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid " + arrowColor,
                        left: 0,
                        top: top,
                    };
                case 'left':
                    return {
                        borderTop: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid transparent",
                        borderLeft: arrowSize + "px solid " + arrowColor,
                        right: 0,
                        top: top,
                    };
                case 'bottom':
                    return {
                        borderLeft: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid transparent",
                        borderBottom: arrowSize + "px solid " + arrowColor,
                        top: 0,
                        left: left,
                    };
                case 'top':
                    return {
                        borderLeft: arrowSize + "px solid transparent",
                        borderRight: arrowSize + "px solid transparent",
                        borderTop: arrowSize + "px solid " + arrowColor,
                        bottom: 0,
                        left: left,
                    };
                default:
                    return {
                        display: 'hidden',
                    };
            }
        })()));
    }, [
        arrowColor,
        arrowSize,
        childRect.height,
        childRect.left,
        childRect.top,
        childRect.width,
        popoverRect.height,
        popoverRect.left,
        popoverRect.top,
        popoverRect.width,
        position,
    ]);
    return {
        arrowContainerStyle: arrowContainerStyle,
        arrowStyle: arrowStyle,
    };
};
useArrowContainer$1.useArrowContainer = useArrowContainer;

var ArrowContainer$1 = {};

var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(ArrowContainer$1, "__esModule", { value: true });
ArrowContainer$1.ArrowContainer = void 0;
var jsx_runtime_1 = require$$0;
var react_1 = React__default;
var useArrowContainer_1 = useArrowContainer$1;
var ArrowContainer = function (_a) {
    var childRect = _a.childRect, popoverRect = _a.popoverRect, position = _a.position, arrowColor = _a.arrowColor, arrowSize = _a.arrowSize, arrowClassName = _a.arrowClassName, externalArrowStyle = _a.arrowStyle, className = _a.className, children = _a.children, externalArrowContainerStyle = _a.style;
    var _b = useArrowContainer_1.useArrowContainer({
        childRect: childRect,
        popoverRect: popoverRect,
        position: position,
        arrowColor: arrowColor,
        arrowSize: arrowSize,
    }), arrowContainerStyle = _b.arrowContainerStyle, arrowStyle = _b.arrowStyle;
    var mergedContainerStyle = react_1.useMemo(function () { return (__assign(__assign({}, arrowContainerStyle), externalArrowContainerStyle)); }, [arrowContainerStyle, externalArrowContainerStyle]);
    var mergedArrowStyle = react_1.useMemo(function () { return (__assign(__assign({}, arrowStyle), externalArrowStyle)); }, [arrowStyle, externalArrowStyle]);
    return (jsx_runtime_1.jsxs("div", __assign({ className: className, style: mergedContainerStyle }, { children: [jsx_runtime_1.jsx("div", { style: mergedArrowStyle, className: arrowClassName }, void 0), children] }), void 0));
};
ArrowContainer$1.ArrowContainer = ArrowContainer;

(function (exports) {
	var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Popover = exports.usePopover = exports.ArrowContainer = exports.useArrowContainer = void 0;
	var jsx_runtime_1 = require$$0;
	var react_1 = React__default;
	var PopoverPortal_1 = PopoverPortal$1;
	var util_1 = util;
	var usePopover_1 = usePopover$1;
	Object.defineProperty(exports, "usePopover", { enumerable: true, get: function () { return usePopover_1.usePopover; } });
	var useMemoizedArray_1 = useMemoizedArray$1;
	var useArrowContainer_1 = useArrowContainer$1;
	Object.defineProperty(exports, "useArrowContainer", { enumerable: true, get: function () { return useArrowContainer_1.useArrowContainer; } });
	var ArrowContainer_1 = ArrowContainer$1;
	Object.defineProperty(exports, "ArrowContainer", { enumerable: true, get: function () { return ArrowContainer_1.ArrowContainer; } });
	var DEFAULT_POSITIONS = ['top', 'left', 'right', 'bottom'];
	var PopoverInternal = react_1.forwardRef(function (_a, externalRef) {
	    var isOpen = _a.isOpen, children = _a.children, content = _a.content, _b = _a.positions, externalPositions = _b === void 0 ? DEFAULT_POSITIONS : _b, _c = _a.align, align = _c === void 0 ? 'center' : _c, _d = _a.padding, padding = _d === void 0 ? 0 : _d, _e = _a.reposition, reposition = _e === void 0 ? true : _e, _f = _a.parentElement, parentElement = _f === void 0 ? window.document.body : _f, _g = _a.boundaryElement, boundaryElement = _g === void 0 ? parentElement : _g, _h = _a.containerClassName, containerClassName = _h === void 0 ? 'react-tiny-popover-container' : _h, containerStyle = _a.containerStyle, contentLocation = _a.contentLocation, _j = _a.boundaryInset, boundaryInset = _j === void 0 ? 0 : _j, onClickOutside = _a.onClickOutside, _k = _a.clickOutsideCapture, clickOutsideCapture = _k === void 0 ? false : _k;
	    var positions = useMemoizedArray_1.useMemoizedArray(externalPositions);
	    // TODO: factor prevs out into a custom prevs hook
	    var prevIsOpen = react_1.useRef(false);
	    var prevPositions = react_1.useRef();
	    var prevContentLocation = react_1.useRef();
	    var prevReposition = react_1.useRef(reposition);
	    var childRef = react_1.useRef();
	    var _l = react_1.useState({
	        align: align,
	        nudgedLeft: 0,
	        nudgedTop: 0,
	        position: positions[0],
	        padding: padding,
	        childRect: util_1.EMPTY_CLIENT_RECT,
	        popoverRect: util_1.EMPTY_CLIENT_RECT,
	        parentRect: util_1.EMPTY_CLIENT_RECT,
	        boundaryRect: util_1.EMPTY_CLIENT_RECT,
	        boundaryInset: boundaryInset,
	        violations: util_1.EMPTY_CLIENT_RECT,
	        hasViolations: false,
	    }), popoverState = _l[0], setPopoverState = _l[1];
	    var onPositionPopover = react_1.useCallback(function (popoverState) { return setPopoverState(popoverState); }, []);
	    var _m = usePopover_1.usePopover({
	        isOpen: isOpen,
	        childRef: childRef,
	        containerClassName: containerClassName,
	        parentElement: parentElement,
	        boundaryElement: boundaryElement,
	        contentLocation: contentLocation,
	        positions: positions,
	        align: align,
	        padding: padding,
	        boundaryInset: boundaryInset,
	        reposition: reposition,
	        onPositionPopover: onPositionPopover,
	    }), positionPopover = _m.positionPopover, popoverRef = _m.popoverRef, scoutRef = _m.scoutRef;
	    react_1.useLayoutEffect(function () {
	        var shouldUpdate = true;
	        var updatePopover = function () {
	            var _a, _b;
	            if (isOpen && shouldUpdate) {
	                var childRect = (_a = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
	                var popoverRect = (_b = popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
	                if (childRect != null &&
	                    popoverRect != null &&
	                    (!util_1.rectsAreEqual(childRect, {
	                        top: popoverState.childRect.top,
	                        left: popoverState.childRect.left,
	                        width: popoverState.childRect.width,
	                        height: popoverState.childRect.height,
	                        bottom: popoverState.childRect.top + popoverState.childRect.height,
	                        right: popoverState.childRect.left + popoverState.childRect.width,
	                    }) ||
	                        popoverRect.width !== popoverState.popoverRect.width ||
	                        popoverRect.height !== popoverState.popoverRect.height ||
	                        popoverState.padding !== padding ||
	                        popoverState.align !== align ||
	                        positions !== prevPositions.current ||
	                        contentLocation !== prevContentLocation.current ||
	                        reposition !== prevReposition.current)) {
	                    positionPopover();
	                }
	                // TODO: factor prev checks out into the custom prevs hook
	                if (positions !== prevPositions.current) {
	                    prevPositions.current = positions;
	                }
	                if (contentLocation !== prevContentLocation.current) {
	                    prevContentLocation.current = contentLocation;
	                }
	                if (reposition !== prevReposition.current) {
	                    prevReposition.current = reposition;
	                }
	                if (shouldUpdate) {
	                    window.requestAnimationFrame(updatePopover);
	                }
	            }
	            prevIsOpen.current = isOpen;
	        };
	        window.requestAnimationFrame(updatePopover);
	        return function () {
	            shouldUpdate = false;
	        };
	    }, [
	        align,
	        contentLocation,
	        isOpen,
	        padding,
	        popoverRef,
	        popoverState.align,
	        popoverState.childRect.height,
	        popoverState.childRect.left,
	        popoverState.childRect.top,
	        popoverState.childRect.width,
	        popoverState.padding,
	        popoverState.popoverRect.height,
	        popoverState.popoverRect.width,
	        positionPopover,
	        positions,
	        reposition,
	    ]);
	    react_1.useEffect(function () {
	        var popoverElement = popoverRef.current;
	        Object.assign(popoverElement.style, containerStyle);
	        return function () {
	            Object.keys(containerStyle !== null && containerStyle !== void 0 ? containerStyle : {}).forEach(function (key) {
	                return delete popoverElement.style[key];
	            });
	        };
	    }, [containerStyle, isOpen, popoverRef]);
	    var handleOnClickOutside = react_1.useCallback(function (e) {
	        var _a, _b;
	        if (isOpen &&
	            !((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) &&
	            !((_b = childRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target))) {
	            onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside(e);
	        }
	    }, [isOpen, onClickOutside, popoverRef]);
	    var handleWindowResize = react_1.useCallback(function () {
	        if (childRef.current) {
	            window.requestAnimationFrame(function () { return positionPopover(); });
	        }
	    }, [positionPopover]);
	    react_1.useEffect(function () {
	        var body = parentElement.ownerDocument.body;
	        body.addEventListener('click', handleOnClickOutside, clickOutsideCapture);
	        body.addEventListener('contextmenu', handleOnClickOutside, clickOutsideCapture);
	        body.addEventListener('resize', handleWindowResize);
	        return function () {
	            body.removeEventListener('click', handleOnClickOutside, clickOutsideCapture);
	            body.removeEventListener('contextmenu', handleOnClickOutside, clickOutsideCapture);
	            body.removeEventListener('resize', handleWindowResize);
	        };
	    }, [clickOutsideCapture, handleOnClickOutside, handleWindowResize, parentElement]);
	    var handleRef = react_1.useCallback(function (node) {
	        childRef.current = node;
	        if (externalRef != null) {
	            if (typeof externalRef === 'object') {
	                externalRef.current = node;
	            }
	            else if (typeof externalRef === 'function') {
	                externalRef(node);
	            }
	        }
	    }, [externalRef]);
	    var renderChild = function () {
	        return react_1.cloneElement(children, {
	            ref: handleRef,
	        });
	    };
	    var renderPopover = function () {
	        if (!isOpen)
	            return null;
	        return (jsx_runtime_1.jsx(PopoverPortal_1.PopoverPortal, __assign({ element: popoverRef.current, scoutElement: scoutRef.current, container: parentElement }, { children: typeof content === 'function' ? content(popoverState) : content }), void 0));
	    };
	    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [renderChild(), renderPopover()] }, void 0));
	});
	exports.Popover = react_1.forwardRef(function (props, ref) {
	    if (typeof window === 'undefined')
	        return props.children;
	    return jsx_runtime_1.jsx(PopoverInternal, __assign({}, props, { ref: ref }), void 0);
	});
	
} (Popover$1));

/**
 * This hook is used to get an element by id and return it, it will wait for the appearance of the element
 * @param id Id of the element
 * @returns The element
 */
var useGetElementById = function (id) {
    var _a = React__default.useState(), element = _a[0], setElement = _a[1];
    useEffect(function () {
        var getElementByIdAsync = function (id) {
            return new Promise(function (resolve) {
                var getElement = function () {
                    var element = document.getElementById(id);
                    if (element) {
                        resolve(element);
                    }
                    else {
                        requestAnimationFrame(getElement);
                    }
                };
                getElement();
            });
        };
        var getParentElement = function () { return __awaiter(void 0, void 0, void 0, function () {
            var element;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getElementByIdAsync(id)];
                    case 1:
                        element = _a.sent();
                        setElement(element);
                        return [2 /*return*/];
                }
            });
        }); };
        getParentElement();
    }, [id]);
    return element;
};

/**
 * Borrowed and modified from react-tiny-popover
 */
var CustomArrowContainer = function (_a) {
    var childRect = _a.childRect, popoverRect = _a.popoverRect, position = _a.position, arrowColor = _a.arrowColor, arrowSize = _a.arrowSize, arrowClassName = _a.arrowClassName, externalArrowStyle = _a.arrowStyle, className = _a.className, children = _a.children, externalArrowContainerStyle = _a.style, htmlProps = __rest(_a, ["childRect", "popoverRect", "position", "arrowColor", "arrowSize", "arrowClassName", "arrowStyle", "className", "children", "style"]);
    var _b = Popover$1.useArrowContainer({
        childRect: childRect,
        popoverRect: popoverRect,
        position: position,
        arrowColor: arrowColor,
        arrowSize: arrowSize,
    }), arrowContainerStyle = _b.arrowContainerStyle, arrowStyle = _b.arrowStyle;
    var mergedContainerStyle = useMemo(function () { return (__assign$2(__assign$2({}, arrowContainerStyle), externalArrowContainerStyle)); }, [arrowContainerStyle, externalArrowContainerStyle]);
    var mergedArrowStyle = useMemo(function () { return (__assign$2(__assign$2({}, arrowStyle), externalArrowStyle)); }, [arrowStyle, externalArrowStyle]);
    return (React__default.createElement(animated.div, __assign$2({ className: className, style: mergedContainerStyle }, htmlProps),
        React__default.createElement("div", { style: mergedArrowStyle, className: arrowClassName }),
        children));
};

var styles = {"popover":"Popover_popover_4a2e3fa2","padding":"Popover_padding_4a2e3fa2","size-small":"Popover_size-small_4a2e3fa2","size-large":"Popover_size-large_4a2e3fa2","overlay":"Popover_overlay_4a2e3fa2","strong":"Popover_strong_4a2e3fa2","black":"Popover_black_4a2e3fa2","animating":"Popover_animating_4a2e3fa2","visuallyHidden":"Popover_visuallyHidden_4a2e3fa2"};

var PopoverContent = React__default.forwardRef(function PopoverContent(props, ref) {
    var children = props.children, _a = props.shadowDepth, shadowDepth = _a === void 0 ? 100 : _a, variant = props.variant, removePadding = props.removePadding, hidden = props.hidden;
    var boxShadow = {
        boxShadow: "var(--box-shadow-".concat(shadowDepth, ")"),
    };
    return (React__default.createElement("div", { ref: ref, className: classNames(styles.popover, styles[variant || "default"], !removePadding && styles.padding, hidden && styles.hidden), style: __assign$2({}, boxShadow) }, children));
});

var Popover = React__default.forwardRef(function Popover(props, ref) {
    var children = props.children, isOpen = props.isOpen, content = props.content, onClose = props.onClose, _a = props.showArrow, showArrow = _a === void 0 ? false : _a, _b = props.placement, positionProp = _b === void 0 ? "bottom" : _b, _c = props.size, size = _c === void 0 ? "fit-content" : _c, _d = props.disableOverlay, disableOverlay = _d === void 0 ? false : _d, className = props.className, popoverClassName = props.popoverClassName, dataTestId = props["data-testid"], _e = props.variant, variant = _e === void 0 ? "default" : _e, _f = props.removePadding, removePadding = _f === void 0 ? false : _f, _g = props.disableScale, disableScale = _g === void 0 ? false : _g, shadowDepth = props.shadowDepth, _h = props.closeOnEscape, closeOnEscape = _h === void 0 ? true : _h, _j = props.alwaysInDom, alwaysInDom = _j === void 0 ? false : _j;
    var _k = useState(false), isOpenAndAnimating = _k[0], setIsOpenAndAnimating = _k[1];
    var _l = useState(false), isAnimating = _l[0], setIsAnimating = _l[1];
    var stackElementId = useStackingContext().stackElementId;
    var parent = useGetElementById(stackElementId);
    var springValues = {
        opacity: isOpen ? 1 : 0,
    };
    if (!disableScale) {
        springValues.transform = isOpen ? "scale(1)" : "scale(0.95)";
    }
    useEffect(function () {
        if (isOpen) {
            setIsOpenAndAnimating(true);
        }
        setIsAnimating(true);
    }, [isOpen]);
    var onAnimationRest = useCallback(function () {
        setIsAnimating(false);
        if (!isOpen) {
            setIsOpenAndAnimating(false);
        }
    }, [isOpen]);
    var springProps = useSpring(__assign$2(__assign$2({}, springValues), { onRest: onAnimationRest }));
    var handleKeyDown = useCallback(function (event) {
        if (closeOnEscape && event.key === "Escape") {
            onClose && onClose();
        }
    }, [onClose, closeOnEscape]);
    useEffect(function () {
        if (isOpen) {
            window.addEventListener("keydown", handleKeyDown, true);
            return function () {
                window.removeEventListener("keydown", handleKeyDown, true);
            };
        }
    }, [isOpen, handleKeyDown]);
    var handleClickOverlay = function (event) {
        event.preventDefault();
        event.stopPropagation();
        onClose && onClose();
    };
    var _m = useMemo(function () {
        var getPosition = function (input) {
            var _a;
            return ((_a = input.match(/(top|bottom|left|right)/)) === null || _a === void 0 ? void 0 : _a[0]) ||
                "bottom";
        };
        var getAlignment = function (input) { var _a; return ((_a = input.match(/(start|end)/)) === null || _a === void 0 ? void 0 : _a[0]) || "center"; };
        if (positionProp instanceof Array) {
            var positions = positionProp.map(getPosition);
            var alignments = positionProp.map(getAlignment);
            return {
                resolvedPositions: positions,
                resolvedAlignment: alignments[0],
            };
        }
        var position = getPosition(positionProp);
        var alignment = getAlignment(positionProp);
        return { resolvedPositions: [position], resolvedAlignment: alignment };
    }, [positionProp]), resolvedPositions = _m.resolvedPositions, resolvedAlignment = _m.resolvedAlignment;
    return (React__default.createElement(React__default.Fragment, null,
        isOpen && !disableOverlay && (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
        React__default.createElement("div", { "aria-hidden": "true", "data-testid": "popover-overlay", onClick: handleClickOverlay, className: styles.overlay })),
        React__default.createElement(Popover$1.Popover, { isOpen: alwaysInDom ? true : isOpenAndAnimating, positions: resolvedPositions, align: resolvedAlignment, containerClassName: className, reposition: true, content: function (_a) {
                var position = _a.position, childRect = _a.childRect, popoverRect = _a.popoverRect;
                var containerStyle = {
                    width: size === "parent" ? childRect.width : undefined,
                };
                if (showArrow)
                    return (React__default.createElement(CustomArrowContainer, { position: position, childRect: childRect, popoverRect: popoverRect, arrowColor: variant === "black"
                            ? "var(--color-black)"
                            : variant === "strong"
                                ? "var(--color-ui-action-mid)"
                                : "var(--color-ui-interface-20)", arrowSize: 8, className: classNames("size-".concat(size), popoverClassName), style: __assign$2(__assign$2({}, containerStyle), springProps), role: "tooltip", "aria-label": "popover", "aria-hidden": false, "aria-busy": isAnimating, "data-is-open": isOpen, "data-testid": dataTestId || "popover" },
                        React__default.createElement(PopoverContent, { variant: variant, removePadding: removePadding, shadowDepth: shadowDepth }, React__default.isValidElement(content)
                            ? content
                            : content(isOpenAndAnimating, isAnimating))));
                return (React__default.createElement(animated.div, { className: classNames("size-".concat(size), !isOpen && styles.animating, alwaysInDom && !isOpenAndAnimating && styles.visuallyHidden, popoverClassName), style: __assign$2(__assign$2({}, containerStyle), springProps), role: "tooltip", "aria-label": "popover", "aria-hidden": false, "aria-busy": isAnimating, "data-is-open": isOpen, "data-testid": dataTestId || "popover" },
                    React__default.createElement(PopoverContent, { variant: variant, removePadding: removePadding, shadowDepth: shadowDepth }, React__default.isValidElement(content)
                        ? content
                        : content(isOpenAndAnimating, isAnimating))));
            }, parentElement: parent || document.body, boundaryElement: document.body, ref: ref }, children)));
});

export { Popover as P, Popover$1 as a, getAugmentedNamespace as b, commonjsGlobal as c, PopoverContent as d, getDefaultExportFromCjs as g, useGetElementById as u };
